import { DhlButton, DhlText } from '@dhl-official/react-library';
import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { useAuthEvents } from './modules/Auth';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import SessionTimeout from '@components/SessionTimetout';

const MainContainer = styled.div`
  display: flex;
  width: 100%;
  margin: auto;
  padding: var(--dui-size-space-4x);
  height: 100%;
`;

const LayoutFooter = styled.div`
    padding-left: 3rem;
    padding-bottom: .5rem;
`;

const BaseContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  gap: 0px 0px;
  grid-template-areas:
    '.'
    '.'
    '.';
  //grid-gap: 10px;
  height: 100vh;

  .inner-content {
    overflow-y: scroll;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
`;
const AlternativeHeader = styled.div`
    background: linear-gradient(90deg, #ffcc00ff 0%, #ffcc00ff 30%, #ffde59ff 73%, #fff0b2ff 100%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
`;


export const Layout = () => {
  const { logout } = useAuthEvents();
  return (
    <BaseContainer>
      <AlternativeHeader>
        <DhlText weight={700} size='2xl'>
          Middle Mile Suppliers
        </DhlText>
        <DhlButton onClick={logout} variant='outline' size='sm' slot='primary-action'>
          Logout
        </DhlButton>
      </AlternativeHeader>
      <main className='inner-content'>
        <ToastContainer />
        <MainContainer>
          <Outlet />
        </MainContainer>
      </main>
      <LayoutFooter>
        {new Date().getFullYear()} © DHL International GmbH. All rights reserved
      </LayoutFooter>
      <SessionTimeout />
    </BaseContainer>
  );
};

export default Layout;
